import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const CONTACT_STEPS = [
    { key: "name", label: "First — your name?", type: "input", placeholder: "Jane Doe" },
    { key: "email", label: "Where can we reach you?", type: "input", placeholder: "you@company.com", inputType: "email" },
    { key: "phone", label: "Your phone number?", type: "input", placeholder: "+91 98765 43210", inputType: "tel" },
    { key: "building", label: "What are you building?", type: "textarea", placeholder: "A product, a course, a launch film..." },
    { key: "audience", label: "Who is it for?", type: "input", placeholder: "Your customers, learners, employees..." },
    { key: "timeline", label: "Timeline?", type: "chips", options: ["Weeks", "Months", "Flexible"] },
    { key: "extra", label: "Anything else we should know?", type: "textarea", placeholder: "Constraints, references, the wild dream..." },
];

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_RE = /^[+\d][\d\s\-()]{6,}$/;

export function useContactForm() {
    const [step, setStep] = useState(0);
    const [data, setData] = useState({ name: "", email: "", phone: "", building: "", audience: "", timeline: "", extra: "" });
    const [submitting, setSubmitting] = useState(false);
    const [done, setDone] = useState(false);

    const cur = CONTACT_STEPS[step];
    const progress = (step + (done ? 1 : 0)) / CONTACT_STEPS.length;
    const isLastStep = step === CONTACT_STEPS.length - 1;

    function update(v) {
        setData((d) => ({ ...d, [cur.key]: v }));
    }

    function next() {
        if (cur.key === "email" && !EMAIL_RE.test(data.email.trim())) {
            toast.error("Please enter a valid email so we can confirm your call.");
            return;
        }
        if (cur.key === "phone" && !PHONE_RE.test(data.phone.trim())) {
            toast.error("Please enter a valid phone number.");
            return;
        }
        if (!isLastStep) setStep((s) => s + 1);
    }

    function back() {
        if (step > 0) setStep((s) => s - 1);
    }

    async function submit() {
        setSubmitting(true);
        try {
            await axios.post(`${API}/contact`, data);
            setDone(true);
            toast.success("Sent. We'll reply within 24h.");
        } catch (err) {
            toast.error("Couldn't send — try again or email team@grow-co.net");
        } finally {
            setSubmitting(false);
        }
    }

    return { step, data, cur, progress, isLastStep, submitting, done, update, next, back, submit };
}
